export default "__VITE_ASSET__B6OGcyc2__"